import React from "react";
import { X, Printer, FlaskConical, CheckCircle2 } from "lucide-react";

const money = (n) => `£${Number(n || 0).toFixed(2)}`;

export default function EposReceipt({ txn, company, onClose }) {
  if (!txn) return null;
  const pay = txn.payments || [];
  return (
    <div className="fixed inset-0 z-[60] bg-black/50 flex items-center justify-center p-4 print:bg-white print:p-0" onClick={onClose} data-testid="epos-receipt-modal">
      <div className="bg-white rounded-xl w-full max-w-sm max-h-[92vh] flex flex-col print:max-w-none print:rounded-none print:shadow-none" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-4 h-12 border-b border-slate-100 print:hidden">
          <span className="inline-flex items-center gap-1.5 text-emerald-600 font-semibold text-sm"><CheckCircle2 className="w-4 h-4" /> Sale complete</span>
          <div className="flex items-center gap-3">
            <button onClick={() => window.print()} data-testid="epos-receipt-print" className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-slate-900"><Printer className="w-4 h-4" /> Print</button>
            <button onClick={onClose}><X className="w-5 h-5 text-slate-400 hover:text-slate-700" /></button>
          </div>
        </div>
        <div className="flex-1 overflow-y-auto p-5 font-mono text-[13px] text-slate-800" data-testid="epos-receipt-body" id="epos-receipt-print">
          <div className="text-center mb-3">
            <div className="font-bold text-base">{company?.name || "Company"}</div>
            <div className="mt-2 inline-block px-3 py-1 rounded bg-amber-100 text-amber-800 text-xs font-bold tracking-wide">
              <FlaskConical className="w-3 h-3 inline mr-1" /> TEST TRANSACTION
            </div>
          </div>
          <div className="text-center text-slate-500 mb-3">Ref: {txn.ref}<br />{new Date(txn.created_at).toLocaleString()}</div>
          <div className="text-slate-500 mb-2">Customer: {txn.customer?.name || "Walk-in Customer"}</div>
          <div className="border-t border-dashed border-slate-300 my-2" />
          {(txn.items || []).map((it, i) => (
            <div key={i} className="flex justify-between gap-2 py-0.5">
              <span className="truncate">{it.qty} × {it.title}</span>
              <span>{money(it.final_gross)}</span>
            </div>
          ))}
          <div className="border-t border-dashed border-slate-300 my-2" />
          <div className="flex justify-between"><span>Subtotal (net)</span><span>{money(txn.subtotal_net)}</span></div>
          {txn.discount?.amount > 0 && <div className="flex justify-between text-rose-600"><span>Discount</span><span>-{money(txn.discount.amount)}</span></div>}
          <div className="flex justify-between"><span>VAT</span><span>{money(txn.vat_total)}</span></div>
          <div className="flex justify-between font-bold text-base border-t border-slate-300 mt-1 pt-1"><span>TOTAL</span><span>{money(txn.total)}</span></div>
          <div className="border-t border-dashed border-slate-300 my-2" />
          {pay.map((p, i) => (
            <div key={i} className="flex justify-between"><span>{p.method === "cash" ? "Cash" : "Card"} (simulated)</span><span>{money(p.amount)}</span></div>
          ))}
          {txn.change_due > 0 && <div className="flex justify-between"><span>Change</span><span>{money(txn.change_due)}</span></div>}
          <div className="text-center text-[11px] text-slate-400 mt-4">Simulated payment — not a real financial record.</div>
        </div>
        <div className="border-t border-slate-100 p-3 print:hidden">
          <button onClick={onClose} data-testid="epos-receipt-newsale" className="w-full px-4 py-2.5 rounded-lg text-sm font-semibold bg-slate-900 text-white hover:bg-slate-800">New sale</button>
        </div>
      </div>
    </div>
  );
}
